var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXPlatform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7746 18.5L27.2624 31.1858L17.7148 41.5H19.8638L28.2228 32.4696L34.9765 41.5H42.2889L32.2671 28.1008L41.154 18.5H39.0051L31.3071 26.8166L25.0871 18.5H17.7746ZM20.9348 20.0827H24.294L39.1284 39.9173H35.7691L20.9348 20.0827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXPlatform);
export default __webpack_public_path__ + "static/media/X_Platform.38e5c83f74c5b48ad869dbae385be3e4.svg";
export { ForwardRef as ReactComponent };